import React from 'react'

export function Table(props){
  const { columnNames=[], data=[], actionButtons=[], rows=[], Row, zeroCaseMessage, zeroCaseButton } = props

  return(
    <div className="w-100">
      { rows.length > 0 ?
        <table className="table table-responsive">
          <thead>
            <tr>
              { columnNames.map((columnName, index)=>(<th key={index}>{columnName}</th>))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index)=><Row key={index} {...row}/>)}
          </tbody>
        </table> :
        <div className="d-flex flex-column align-items-center">
          { zeroCaseMessage && <div className="text-secondary">{zeroCaseMessage}</div> }
          { zeroCaseButton && <button onClick={zeroCaseButton.handleClick} className="btn btn-primary mt-3">{zeroCaseButton.label}</button> }
        </div>
      }
    </div>
  )
}

export default Table